import * as React from "react";
import { connect } from "react-redux";
import {
    addToSelectedItems,
    removeFromSelectedItems,
    clearAllSelectedItems,
    selectedAllItems,
    deselectedAllItems,
} from "actions/bulk-items";
import theme from "styles/theme";
import { clearViews, fetchViewForSchema } from "actions/views";
import { VIEW_ITEM_TILE, VIEW_PRODUCT_LIST } from "constants/view-defs";
import { ConnectedPage as Page } from "components/page/page";
import { formatMessage } from "lib/globalize-util";
import Items from "components/items";
import { activeListAdd, activeListRemoveAndDelete, activeListFetchEntries, activeListSet } from "actions/active-list";
import { fetchProducts, fetchProductsNextPage } from "actions/products";
import { toggleGalleryInsightsSidePanel } from "actions/insights-actions";
import { fetchProductBadges } from "actions/insights/product-badges";
import * as PropTypes from "prop-types";
import { merge } from "glamor";
import me from "models/me";
import { Map, fromJS } from "immutable";
import ActionBar from "components/page/action-bar";
import IconButton from "material-ui/IconButton";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import ActionHistory from "material-ui/svg-icons/action/history";
import { add as snackbarAdd } from "actions/snackbars";
import { cartFetch, syncFromCart } from "actions/cart";
import { fetchTemplates } from "actions/templates-actions";
import { fetchTempates as fetchCustomAtsTemplates } from "actions/ats-custom-template-actions";
import { SchemaRecord } from "records/schema";
import { redirectToProduct } from "../actions/item";
import { IItemRecord } from "../records/item/item";
import { IPromotionsData } from "constants/promotion-types";
import { PromotionDetails, NoPromotionForCompany } from "components/item/promotion-details";
import { TFDMCompanyRecord } from "records/company/company";
import { IOrder } from "records/order";
import { fetchStartOrderCompanies, setViewType } from "actions/scope";
import _ from "lodash";
import { ITemplatePreview } from "constants/template-types";
import { ItemViewType } from "constants/types";
import { getDefaultView } from "components/items/items-utils";
import { getOrder } from "components/build-order";
import { PRODUCTS_FILTER } from "constants/brand-settings";
import { fetchPredefined } from "actions/delivery-windows";
import type { IDeliveryWindow } from "constants/delivery-windows";
import { getViewDef } from "helpers/view-def";
import OrderInsightsGallery from "components/insights-side-panel/order-trends-gallery";
import {
    insightsViewedAsMainUser,
    isInsightsEnabledWithCurrency,
    isInsightsSidePanelOpenInGallery,
} from "reducers/insights-reducer";

const NAMESPACE = "gallery";

class Actions extends React.PureComponent<any, any> {
    static propTypes = {
        recentlyViewedItems: PropTypes.object.isRequired,
        onPreview: PropTypes.func.isRequired,
    };

    handlePreview(item, e) {
        const { onPreview } = this.props;
        onPreview(item);
    }

    renderHistory() {
        const { recentlyViewedItems } = this.props;
        const products = recentlyViewedItems.map((item) => {
            return <MenuItem key={item._id} primaryText={item.name} onClick={this.handlePreview.bind(this, item)} />;
        });
        return (
            <IconMenu
                key="history-dropdown"
                iconButtonElement={
                    <IconButton key="history" tooltip={formatMessage("Recently Viewed")} tooltipPosition="bottom-left">
                        <ActionHistory />{" "}
                    </IconButton>
                }
            >
                {products}
            </IconMenu>
        );
    }

    render() {
        const { recentlyViewedItems } = this.props;

        return <ActionBar>{recentlyViewedItems && recentlyViewedItems.size > 0 && this.renderHistory()}</ActionBar>;
    }
}

const PAGE_SIZE = 50;
const MOBILE_PAGE_SIZE = 20;

export function translateValues(gallerySort) {
    let sort = "";
    let sortOrder = "";

    switch (gallerySort) {
        case "merchandised":
            sort = "__merchandising_order";
            sortOrder = "asc";
            break;
        case "created_on":
            sort = "__created_on";
            sortOrder = "desc";
            break;
        case "name_asc":
            sort = "name";
            sortOrder = "asc";
            break;
        case "name_desc":
            sort = "name";
            sortOrder = "desc";
            break;
        case "style_asc":
            sort = "style_number";
            sortOrder = "asc";
            break;
        case "style_desc":
            sort = "style_number";
            sortOrder = "desc";
            break;
        default:
            sort = "__created_on";
            sortOrder = "desc";
    }

    return { sort, sortOrder };
}

interface IStateToProps {
    activeList: any;
    app: any;
    bulkItems: any;
    cart: any;
    entities: any;
    previewProduct: any;
    products: any;
    orderPromotions?: IPromotionsData;
    routing: any;
    scope: any;
    sortBy: string;
    sortOrder: string;
    templates?: any;
    fetchingCompanies: boolean;
    companies: TFDMCompanyRecord[];
    companyIds: string[];
    hasMoreCompanies: boolean;
    atsCustomTemplates?: ITemplatePreview[];
    viewDef: any;
    viewDefs: any;
    productSchema?: SchemaRecord;
    deliveryWindows: IDeliveryWindow[];
    fetchingWindows: boolean;
    isInsightsSidePanelOpen: boolean;
    isOrderTrendsEnabled: boolean;
    insightsViewedAsMainUser: boolean;
    isPDPSidePanelOpen: boolean;
}

interface IActions {
    onActiveListAdd: (productId: string) => void;
    onActiveListRemove: (productId: string) => void;
    onActiveListFetchEntries: () => void;
    onSetActiveList: (catalog: any, options: any) => void;
    onClearViewDefs: () => void;
    onFetchView: (viewName: string, schemaId: string) => void;
    onAddToSelectedProducts: (productId: string) => void;
    onRemoveFromSelectedItems: (productId: string) => void;
    onSnackbarAdd: (params: any) => void;
    onFetchStartOrderCompanies: (params: any) => void;
    onCartFetch: (params: any) => void;
    onSyncFromCart: (order: IOrder, meta: { syncToCart?: boolean } | any) => void;
    onClearAllSelectedProducts: () => void;
    onToggleBulkSelectAll: (e, checked) => void;
    onFetchTemplates: () => void;
    onFetchAtsCustomTemplates: () => void;
    onFetchProducts: (cacheKey: string, parameters: any) => void;
    onFetchProductsNextPage: (nextPage: string) => void;
    onPreviewProduct: (product: Pick<IItemRecord, "_id" | "name">, location) => void;
    onViewChange: (viewType: string, brandId: string) => void;
    onFetchDeliveryWindows: () => void;
    onToggleInsightsSidePanel: () => void;
    onFetchBadges: () => void;
}

interface IProps extends IStateToProps, IActions {
    params: any;
    location: any;
    router: any;
}

interface IState {
    view?: string;
    recentlyViewedItems?: any;
    filters?: any;
}

export class Gallery extends React.PureComponent<IProps, IState> {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    private styles = merge({
        margin: "0 15px",
    });

    constructor(props) {
        super(props);

        this.handleRefresh = this.handleRefresh.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (!this.props.templates) {
            this.props.onFetchTemplates();
        }
        if (!this.props.atsCustomTemplates) {
            this.props.onFetchAtsCustomTemplates();
        }
        this.setFiltersAndFetchProducts(this.props);
        const view = this.context.me.getViewPref("item_grid_view_preference") || getDefaultView();
        this.setState({
            view,
            recentlyViewedItems: this.props.scope.brand.getRecentlyViewedItems(),
        });
        this.handleFetchViewDefinition(this.props, view === ItemViewType.List ? VIEW_PRODUCT_LIST : VIEW_ITEM_TILE);
        this.props.onCartFetch(null);
    }

    componentWillUnmount() {
        this.props.onClearAllSelectedProducts();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.scope.brand._id !== this.props.scope.brand._id &&
            !nextProps.viewDef.isFetching &&
            !nextProps.viewDef.error
        ) {
            this.handleFetchViewDefinition(
                nextProps,
                this.state.view === ItemViewType.List ? VIEW_PRODUCT_LIST : VIEW_ITEM_TILE,
            );
        }

        const useAdvancedPricing = nextProps.scope.brand.isPricingPromotionEnabled(nextProps.scope);
        // See if the source of truth changed and set filters
        if (
            this.props.location.query.filters !== nextProps.location.query.filters ||
            this.props.sortBy !== nextProps.sortBy ||
            this.props.sortOrder !== nextProps.sortOrder ||
            this.props.scope.viewAs !== nextProps.scope.viewAs ||
            (useAdvancedPricing && this.props.scope.currencyCode !== nextProps.scope.currencyCode) ||
            this.props.scope.viewAsGuest !== nextProps.scope.viewAsGuest ||
            (nextProps.scope.brand.hasPreference("set_warehouse_for_linesheets") &&
                _.get(getOrder(this.props.cart), "selected_warehouse") !==
                    _.get(getOrder(nextProps.cart), "selected_warehouse")) ||
            nextProps.products?.refresh
        ) {
            this.setFiltersAndFetchProducts(nextProps);
        }

        if (nextProps.previewProduct.error && nextProps.previewProduct.error !== this.props.previewProduct.error) {
            if (nextProps.previewProduct.error.code === 404) {
                nextProps.onSnackbarAdd({
                    message: formatMessage("Product is not available in this color"),
                });
            }
        }
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        const currentView = this.state.view === ItemViewType.List ? VIEW_PRODUCT_LIST : VIEW_ITEM_TILE;
        const nextView = nextState.view === ItemViewType.List ? VIEW_PRODUCT_LIST : VIEW_ITEM_TILE;
        if (currentView !== nextView) {
            this.handleFetchViewDefinition(nextProps, nextView);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.scope.brand._id !== prevProps.scope.brand._id) {
            this.handleBrandChange();
        }
    }

    generateQueryParams(filters, props = this.props) {
        const { scope } = props;
        const order = getOrder(props.cart);
        const query: any = {
            __active_pricesheet: me._activePriceTemplate,
            __archived: false,
            __fields: "__all",
            __limit: PAGE_SIZE,
            __meta: true,
            __populate: this.props.scope.brand.hasPreference("external_color_variants")
                ? "__variant_count"
                : "__variant",
            __sort: props.sortBy,
            __sort_order: props.sortOrder,
            __view_disabled: false,
        };

        query.__advanced_pricing_currency_code = scope.brand?.getAdvancedPricingCurrencyCode(scope);

        if (props.scope.viewAs) {
            query.__company = props.scope.viewAs._id;
        }

        if (props.scope.viewAsGuest) {
            query.__guest = "true";
        }

        const useOrderWarehouseFiltering =
            this.props.scope.brand.hasPreference("set_warehouse_for_linesheets") &&
            this.props.scope.brand.getPreference("filter_products_by") === PRODUCTS_FILTER.BY_WAREHOUSE_IN_WO;
        if (useOrderWarehouseFiltering && order?.selected_warehouse) {
            query.__warehouses = [order.selected_warehouse];
        }

        if (filters.size > 0) {
            filters = filters.toJS();
            if (filters.__active) {
                switch (filters.__active) {
                    case "active":
                        filters.__active = true;
                        break;
                    case "inactive":
                        filters.__view_disabled = true;
                        filters.__active = false;
                        break;
                    default:
                        filters.__view_disabled = true;
                        delete filters.__active;
                }
            }
            Object.assign(query, filters);
        }
        return query;
    }

    addToHistory(item) {
        const { brand } = this.props.scope;
        this.setState({
            recentlyViewedItems: brand.pushItemViewed(item),
        });
    }

    render() {
        const { me } = this.context;
        const {
            activeList,
            app,
            bulkItems,
            cart,
            children,
            products,
            entities,
            onActiveListAdd,
            onActiveListFetchEntries,
            onActiveListRemove,
            onClearAllSelectedProducts,
            onSetActiveList,
            onSnackbarAdd,
            onToggleBulkSelectAll,
            onFetchStartOrderCompanies,
            fetchingCompanies,
            companies,
            companyIds,
            hasMoreCompanies,
            onCartFetch,
            onSyncFromCart,
            previewProduct,
            scope,
            sortBy,
            sortOrder,
            templates,
            atsCustomTemplates,
            viewDef,
            viewDefs,
            productSchema,
            orderPromotions,
            deliveryWindows,
            fetchingWindows,
            onFetchDeliveryWindows,
            isInsightsSidePanelOpen,
            onToggleInsightsSidePanel,
            isOrderTrendsEnabled,
            isPDPSidePanelOpen,
        } = this.props;

        const { view, recentlyViewedItems, filters } = this.state;

        return (
            <Page
                title={formatMessage("Browse Products")}
                openNavSection="wholesale"
                viewport={app.viewport}
                actions={<Actions recentlyViewedItems={recentlyViewedItems} onPreview={this.handlePreviewProduct} />}
                panel={
                    isOrderTrendsEnabled &&
                    !isPDPSidePanelOpen && (
                        <OrderInsightsGallery
                            onToggleInsightsSidePanel={onToggleInsightsSidePanel}
                            location={this.props.location}
                        />
                    )
                }
                panelSize={isInsightsSidePanelOpen ? theme.insightsSidePanel.width : 0}
                notificationPanel={
                    <div {...this.styles}>
                        <NoPromotionForCompany
                            promotions={orderPromotions}
                            fetchingCompanies={fetchingCompanies}
                            onFetchStartOrderCompanies={onFetchStartOrderCompanies}
                            onSnackbarAdd={onSnackbarAdd}
                            onSyncFromCart={onSyncFromCart}
                            onCartFetch={onCartFetch}
                            companies={companies}
                            companyIds={companyIds}
                            hasMoreCompanies={hasMoreCompanies}
                            cart={cart}
                            user={me}
                            scope={scope}
                        />
                        <PromotionDetails
                            promotions={orderPromotions}
                            pricingPromotionEnabled={scope.brand.isPricingPromotionEnabled(scope)}
                            // Total applied should be hidden until Pricing BE ticket will be fixed NU-23424
                            // totalApplied={orderPromotions.totalApplied}
                        />
                    </div>
                }
            >
                <Items
                    activeBrand={scope.brand}
                    activeList={activeList}
                    app={app}
                    bulkItems={bulkItems}
                    cart={cart}
                    entities={entities}
                    filters={filters}
                    hasMoreResults={products.hasMoreResults}
                    isFetching={products.isFetching}
                    isGuestBuyer={me.isGuestBuyer()}
                    onActiveListAdd={onActiveListAdd}
                    onActiveListFetchEntries={onActiveListFetchEntries}
                    onActiveListRemove={onActiveListRemove}
                    onAddToSelectedItems={this.props.onAddToSelectedProducts}
                    onClear={onClearAllSelectedProducts}
                    onFetchNextPage={this.handleFetchNextPage}
                    onFilterChange={this.handleFilterChange}
                    onInventoryFilterChange={this.handleInventoryFilterChange}
                    onItemClick={this.handlePreviewProduct}
                    onRemoveFromSelectedItems={this.props.onRemoveFromSelectedItems}
                    onSelectAll={onToggleBulkSelectAll}
                    onSetActiveList={onSetActiveList}
                    onSnackbarAdd={onSnackbarAdd}
                    onSortChange={this.handleSortChange}
                    onViewChange={this.handleViewChange}
                    productSchema={productSchema}
                    pageSize={app.touchDevice ? MOBILE_PAGE_SIZE : PAGE_SIZE}
                    previewItem={previewProduct}
                    results={products.results}
                    router={this.props.router}
                    scope={scope}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    templates={templates}
                    atsCustomTemplates={atsCustomTemplates}
                    type="item"
                    view={view}
                    viewDef={viewDef}
                    viewDefs={viewDefs}
                    onEntriesRefresh={this.handleRefresh}
                    deliveryWindows={deliveryWindows}
                    fetchingWindows={fetchingWindows}
                    onFetchDeliveryWindows={onFetchDeliveryWindows}
                    isInsightsSidePanelOpen={isInsightsSidePanelOpen}
                />
                {children}
            </Page>
        );
    }

    private handleRefresh(props = this.props) {
        const { onFetchProducts } = props;
        const cacheKey = this.getCacheKey(props);
        onFetchProducts(cacheKey, this.generateQueryParams(this.state.filters, props));
    }

    private setFiltersAndFetchProducts(props = this.props, forceUpdate = false) {
        const { location, products, onFetchProducts, onFetchBadges, insightsViewedAsMainUser } = props;

        if (insightsViewedAsMainUser) {
            onFetchBadges();
        }

        let filters = Map();
        try {
            filters = fromJS(JSON.parse(location.query.filters || "{}"));
        } catch (e) {
            // No-op
        }
        const cacheKey = this.getCacheKey(props);
        if (forceUpdate || cacheKey !== products.cacheKey) {
            onFetchProducts(cacheKey, this.generateQueryParams(filters, props));
        }
        this.setState({ filters });
    }

    private updateLocation(query, router, pathname) {
        router.replace({ pathname, query });
    }

    private handleFilterChange = (filters) => {
        // URL is the source for truth, set and let info flow down
        const { router, routing, onClearAllSelectedProducts, location } = this.props;
        const query = { ...location.query };
        delete query.filters;
        onClearAllSelectedProducts();
        if (filters.size > 0) {
            query.filters = JSON.stringify(filters.toJS());
        }
        this.updateLocation(query, router, routing.locationBeforeTransitions.pathname);
        this.setState({ filters });
    };

    private handleInventoryFilterChange = (filters) => {
        // URL is the source for truth, set and let info flow down
        const { router, routing, onClearAllSelectedProducts, location } = this.props;
        const query = { ...location.query };
        delete query.filters;
        onClearAllSelectedProducts();
        if (filters.size > 0) {
            query.filters = JSON.stringify(filters.toJS());
        }
        const invRollupIs = filters.get("__inventory_rollup_is");
        const invRollupQty = filters.get("__inventory_rollup_qty");
        const filtersIncludeInv = (location.query.filters || "").includes("__inventory_rollup_is");

        if ((invRollupIs && invRollupQty) || (filtersIncludeInv && !invRollupIs && !invRollupQty)) {
            this.updateLocation(query, router, routing.locationBeforeTransitions.pathname);
        }
        this.setState({ filters });
    };

    private handleSortChange = (e, index, value) => {
        this.props.onClearAllSelectedProducts();
        const query = this.props.location.query;
        query.sort = value || index;
        this.props.router.replace({
            pathname: this.props.location.pathname,
            query,
        });
    };

    private handleFetchNextPage = () => {
        const { onFetchProductsNextPage, products } = this.props;
        onFetchProductsNextPage(products.nextPage);
    };

    private handlePreviewProduct = (product: Pick<IItemRecord, "_id" | "name">) => {
        const { location } = this.props;
        this.props.onPreviewProduct(product, location);
        this.addToHistory(product);
    };

    private handleViewChange = (view) => {
        this.setState({ view });

        const { onViewChange, scope } = this.props;
        onViewChange(view, _.get(scope, "brand._id"));
    };

    private getCacheKey(props = this.props) {
        const { params, location, sortBy, sortOrder, scope } = props;
        let key = `${params.brand}::${location.query.filters || ""}::${sortBy}.${sortOrder}`;
        const order = getOrder(props.cart);

        if (scope.currencyCode) {
            key = `${key}::currencyCode:${props.scope.currencyCode}`;
        }

        if (scope.viewAs) {
            key = `${key}::company:${props.scope.viewAs._id}`;
        }

        if (scope.viewAsGuest) {
            key = `${key}::company:guest`;
        }

        const useOrderWarehouseFiltering =
            scope.brand.hasPreference("set_warehouse_for_linesheets") &&
            scope.brand.getPreference("filter_products_by") === PRODUCTS_FILTER.BY_WAREHOUSE_IN_WO;
        if (useOrderWarehouseFiltering && order?.selected_warehouse) {
            key = `${key}::selectedWarehouse:${order.selected_warehouse}`;
        }

        return key;
    }

    private handleBrandChange = () => {
        this.props.onClearViewDefs();
        this.props.onClearAllSelectedProducts();
        this.props.onFetchTemplates();
        this.setState({
            view: this.context.me.getViewPref("item_grid_view_preference") || getDefaultView(),
            recentlyViewedItems: this.props.scope.brand.getRecentlyViewedItems(),
        });
    };

    private handleFetchViewDefinition = (props = this.props, viewName) => {
        const schema = props.scope.brand.getSchema("product");
        const viewDef = getViewDef({
            viewName,
            ids: props.viewDef.result,
            entries: props.viewDefs,
            schema,
        });
        if (!viewDef) {
            props.onFetchView(viewName, schema._id);
        }
    };
}

const getSort = (state, ownProps) => {
    let [sort, sortOrder = ""] = (ownProps.location.query.sort || "").split(".");

    // if there is no sort params in url, lets search some in viewPreferences
    if (!sort && !sortOrder) {
        const sortBrandPreference = state.scope.brand.hasPreference("gallery_sort");
        const sortUserPreference = me.getViewPref("gallery_sort");

        if (sortUserPreference) {
            [sort, sortOrder = ""] = (sortUserPreference || "").split(".");
        } else if (sortBrandPreference) {
            const translatedValues = translateValues(sortBrandPreference);
            sort = translatedValues.sort;
            sortOrder = translatedValues.sortOrder;
        }
    }

    return [sort || "__created_on", sortOrder || "desc"];
};

const mapStateToProps = (state, ownProps) => {
    const [sortBy, sortOrder] = getSort(state, ownProps);
    let productSchema = null;

    state.schemas.result.some((id) => {
        if (state.entities.schemas[id] && state.entities.schemas[id].type === "product") {
            productSchema = state.entities.schemas[id];
        }
    });

    return {
        cart: state.cart,
        activeList: state.activeList,
        previewProduct: state.item,
        entities: state.entities,
        products: state.products.collections[NAMESPACE] || {
            results: [],
            isFetching: false,
            hasMoreResults: false,
        },
        viewDef: state.views,
        viewDefs: state.entities.views || {},
        bulkItems: state.bulkItems,
        orderPromotions: state.orderPromotions,
        app: state.app,
        scope: state.scope,
        sortBy,
        sortOrder,
        routing: state.routing,
        templates: state.templates.payload,
        atsCustomTemplates: state.atsCustomTemplates.list.payload,
        companies: state.entities.companies,
        companyIds: state.scope.startOrderCompanies,
        fetchingCompanies: state.scope.fetchingStartOrderCompanies,
        hasMoreCompanies: state.scope.nextPageStartOrderCompanies,
        productSchema,
        deliveryWindows: state.deliveryWindows.predefined.payload,
        fetchingWindows: state.deliveryWindows.predefined.isFetching,
        isInsightsSidePanelOpen: isInsightsSidePanelOpenInGallery(state),
        isPDPSidePanelOpen: state.app.sidePanelOpen,
        isOrderTrendsEnabled: isInsightsEnabledWithCurrency(state),
        insightsViewedAsMainUser: insightsViewedAsMainUser(state),
    };
};

const mapDispatchToProps = (dispatch): IActions => {
    return {
        onActiveListAdd: (itemId) => dispatch(activeListAdd(itemId)),
        onActiveListRemove: (itemId) => dispatch(activeListRemoveAndDelete(itemId)),
        onActiveListFetchEntries: () => dispatch(activeListFetchEntries()),
        onSetActiveList: (catalog, options) => dispatch(activeListSet(catalog, options)),
        onClearViewDefs: () => dispatch(clearViews()),
        onFetchView: (viewName, schemaId) => dispatch(fetchViewForSchema(viewName, schemaId, false)),
        onAddToSelectedProducts: (id) => dispatch(addToSelectedItems(id)),
        onRemoveFromSelectedItems: (id) => dispatch(removeFromSelectedItems(id)),
        onSnackbarAdd: (params) => dispatch(snackbarAdd(params)),
        onClearAllSelectedProducts: () => dispatch(clearAllSelectedItems()),
        onToggleBulkSelectAll: (e, checked) => dispatch(checked ? selectedAllItems() : deselectedAllItems()),
        onFetchTemplates: () => dispatch(fetchTemplates()),
        onCartFetch: (options) => dispatch(cartFetch(options)),
        onSyncFromCart: (order, meta) => dispatch(syncFromCart(order, meta)),
        onFetchStartOrderCompanies: (params) => dispatch(fetchStartOrderCompanies(params)),
        onFetchAtsCustomTemplates: () => dispatch(fetchCustomAtsTemplates()),
        onFetchProducts: (cacheKey, filters) => dispatch(fetchProducts(NAMESPACE, cacheKey, filters)),
        onFetchProductsNextPage: (nextPage) => dispatch(fetchProductsNextPage(NAMESPACE, nextPage)),
        onPreviewProduct: (product: Pick<IItemRecord, "_id" | "name">, location) =>
            dispatch(redirectToProduct(product._id, location)),
        onViewChange: (viewType: string, brandId: string) => dispatch(setViewType(viewType, brandId)),
        onFetchDeliveryWindows: () => dispatch(fetchPredefined()),
        onToggleInsightsSidePanel: () => dispatch(toggleGalleryInsightsSidePanel()),
        onFetchBadges: () => dispatch(fetchProductBadges()),
    };
};

export const GalleryContainer = connect(mapStateToProps, mapDispatchToProps)(Gallery);
export default GalleryContainer;
